// extracted by mini-css-extract-plugin
export default {"HumanInfoComponent":"HumanInfoComponent_HumanInfoComponent__D-2wr"};